import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import UIContainer from '../UIComponents/UIContainer';
import HubspotWrapper from './HubspotWrapper';
import { pluginPath } from '../../constants/leadinConfig';
import { __ } from '@wordpress/i18n';
export default function PreviewDisabled() {
    const errorHeader = __('Preview Unavailable', 'leadin');
    const errorMessage = `${__('This block cannot be previewed within the Full Site Editor', 'leadin')} ${__('Switch to the Block Editor to view the content', 'leadin')}`;
    return (_jsx(HubspotWrapper, { pluginPath: pluginPath, children: _jsxs(UIContainer, { textAlign: "center", children: [_jsx("h4", { children: errorHeader }), _jsx("p", { children: _jsx("b", { children: errorMessage }) })] }) }));
}
